export default __webpack_public_path__ + "img/it-consulting-support.69f36b6e.png";